import React from 'react';
import Locale from "../util/Locale";
import {Image} from "antd";

function Service() {
    return (
        <div className="dark:bg-gray-800 relative flex-grow">
            <div className="overflow-hidden relative">
                <section className="relative z-10 dark:bg-gray-800 bg-white ">
                    <div className="pt-8 px-4 mx-auto  max-w-screen-xl sm:pt-16 lg:px-6 pb-4 sm:pb-12">
                        <div className="">
                            <h2 className=" text-4xl tracking-tight font-extrabold text-gray-900 dark:text-white">
                                <Locale code={'menu.service'}/>
                            </h2>
                        </div>
                    </div>
                </section>
                <div>
                    <div id="management">
                        <section className="pb-4 lg:rotate-[8deg] bg-gray-200 dark:bg-gray-700">
                            <div className="px-4 mx-auto max-w-screen-xl sm:pb-24 pt-12 lg:px-6 lg:-rotate-[8deg]">
                                <div>
                                    <div className="sm:w-[396px] mb-5 w-full float-left mr-8">
                                        <Image preview={false} alt="working" className="w-full rounded-lg"
                                               src="/images/working.jpg"/>
                                    </div>
                                    <Locale code={'service.management'}/>
                                </div>
                            </div>
                        </section>
                    </div>
                    <div id="controlling">
                        <section className="pb-4 lg:rotate-[8deg]">
                            <div className="px-4 mx-auto max-w-screen-xl sm:pb-24 pt-12 lg:px-6 lg:-rotate-[8deg]">
                                <div>
                                    <div className="sm:w-[396px] mb-5 w-full float-right ml-8">
                                        <Image preview={false} alt="working" className="w-full rounded-lg"
                                               src="/images/controlling.jpg"/>
                                    </div>
                                    <Locale code={'service.controlling'}/>
                                </div>
                            </div>
                        </section>
                    </div>
                    <div id="reporting">
                        <section className="pb-4 lg:rotate-[8deg] bg-gray-200 dark:bg-gray-700">
                            <div className="px-4 mx-auto max-w-screen-xl sm:pb-24 pt-12 lg:px-6 lg:-rotate-[8deg]">
                                <div>
                                    <div className="sm:w-[396px] mb-5 w-full float-left mr-8">
                                        <Image preview={false} alt="working" className="w-full rounded-lg"
                                               src="/images/profit.jpg"/>
                                    </div>
                                    <Locale code={'service.reporting'}/>
                                </div>
                            </div>
                        </section>
                    </div>
                    <div id="development">
                        <section className="pb-4 lg:rotate-[8deg]">
                            <div className="px-4 mx-auto max-w-screen-xl sm:pb-24 pt-12 lg:px-6 lg:-rotate-[8deg]">
                                <div>
                                    <div className="sm:w-[396px] mb-5 w-full float-right ml-8">
                                        <Image preview={false} alt="working" className="w-full rounded-lg"
                                               src="/images/development.jpg"/>
                                    </div>
                                    <Locale code={'service.development'}/>
                                </div>
                            </div>
                        </section>
                    </div>
                    <div id="education">
                        <section className="pb-4 lg:rotate-[8deg] bg-gray-200 dark:bg-gray-700">
                            <div className="px-4 mx-auto max-w-screen-xl sm:pb-24 pt-12 lg:px-6 lg:-rotate-[8deg]">
                                <div>
                                    <div className="sm:w-[396px] mb-5 w-full float-left mr-8">
                                        <Image preview={false} alt="working" className="w-full rounded-lg"
                                               src="/images/education.jpg"/>
                                    </div>
                                    <Locale code={'service.education'}/>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Service;
